/* eslint-disable default-param-last */
import {
  SET_CERT_LIST_BULK_FOOTER_VISIBLE,
  SET_CERT_LIST_IS_BULK_ACTION_ENABLED,
  SET_CERT_LIST_IS_BULK_DISABLED,
  SET_CERT_LIST_IS_BULK_INTERMIDIATE,
  SET_CERT_LIST_IS_BULK_SELECT_CHECKED,
  SET_CERT_LIST_IS_SELECTING_BULK,
  SET_CERT_LIST_IS_SUBMITTING_BULK_ACTION,
} from '../types';

const INITIAL_STATE = {
  isBulkActionEnabled: false, // We are not doing it right now as APIs are not supported
  isBulkChecked: false,
  isBulkFooterVisible: false,
  isBulkDisabled: false,
  isBulkSubmittingAction: false,
  isBulkIndeterminate: false,
  isBulkSelecting: false,
};

const bulkActionReducer = (state = INITIAL_STATE, action) => {
  switch (action?.type) {
    case SET_CERT_LIST_IS_BULK_ACTION_ENABLED:
      return {
        ...state,
        isBulkActionEnabled: action?.payload,
      };

    case SET_CERT_LIST_IS_BULK_SELECT_CHECKED:
      return {
        ...state,
        isBulkChecked: action?.payload,
      };

    case SET_CERT_LIST_BULK_FOOTER_VISIBLE:
      return {
        ...state,
        isBulkFooterVisible: action?.payload,
      };

    case SET_CERT_LIST_IS_BULK_DISABLED:
      return {
        ...state,
        isBulkDisabled: action?.payload,
      };

    case SET_CERT_LIST_IS_SUBMITTING_BULK_ACTION:
      return {
        ...state,
        isBulkSubmittingAction: action?.payload,
      };

    case SET_CERT_LIST_IS_BULK_INTERMIDIATE:
      return {
        ...state,
        isBulkIndeterminate: action?.payload,
      };

    case SET_CERT_LIST_IS_SELECTING_BULK:
      return {
        ...state,
        isBulkSelecting: action?.payload,
      };

    default:
      return state;
  }
};

export default bulkActionReducer;
